import { Card, CardBody } from '@backstage/ui'
import { Typography } from '@material-ui/core'
import { Entity } from '@backstage/catalog-model'

type Props = {
  podEntity?: Entity
  baEntity?: Entity
}

export const UserGroupCard = ({ podEntity, baEntity }: Props) => {
  const groupEntity = podEntity ?? baEntity
  const groupName = groupEntity?.metadata?.title || groupEntity?.metadata?.name
  const groupType = podEntity ? 'Pod' : baEntity ? 'Business Area' : undefined

  if (!groupEntity) return null

  return (
    <Card>
      <CardBody>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Member of {groupType}
        </Typography>
        <Typography variant="h6" data-testid="user-group-name">
          {groupName}
        </Typography>
      </CardBody>
    </Card>
  )
}
